import { FormControlLabel, Switch } from "@mui/material";
import { useTenantTranslation } from "src/hooks/formatters";
import { changeHotkeysEnabled } from "src/store/slices/settings";
import { useAppDispatch } from "src/store/store";
import { useHotkeysEnabled } from "src/hooks/settings";

export const HotkeysToggle = () => {
  const { t } = useTenantTranslation();
  const dispatch = useAppDispatch();
  const hotkeysEnabled = useHotkeysEnabled();

  const handleHotkeysToggle = () => {
    dispatch(changeHotkeysEnabled(!hotkeysEnabled));
  };

  return (
    <FormControlLabel
      control={
        <Switch onChange={handleHotkeysToggle} checked={hotkeysEnabled} />
      }
      label={t("enableHotkeys")}
    />
  );
};
